import { createReducer, on } from "@ngrx/store";
import {
  clearAuthSession,
  initializeWithToken,
  initializeWithNoToken,
  saveAuthUserInfo,
  saveRubickResponse,
  setAuthError,
  setAuthLoading
} from "../actions/auth";
import {
  adminLoginFailure,
  adminLoginRedirectStarted,
  adminLoginRequest,
  adminLoginSuccess,
  adminLogout,
  adminSessionExpired,
  adminTokenRefreshSucceeded,
  emailValidationFailure,
  emailValidationRequest,
  emailValidationSuccess,
  restoreAdminSession
} from "../../../../core/auth/store/auth.actions";
import { credentialsLoginMfaFallbackRequested } from "../../../../features/login/store/login.actions";
import { getInitialState } from "./initial.state";
import { AppState } from "../../types/app-state";

const initialState = getInitialState();

export const appStateReducer = createReducer(
  initialState,

  on(
    restoreAdminSession,
    adminLoginSuccess,
    adminTokenRefreshSucceeded,
    (state, { token, expiresAt, sessionId, role, userProfile }): AppState => ({
      ...state,
      accessToken: token,
      refreshToken: undefined,
      expiresAt,
      sessionId,
      accountType: role,
      hasHydrated: true,
      authLoading: false,
      authError: null,
      authUserInfo: null,
      userDetails: {
        ...state.userDetails,
        isLoading: false,
        error: null,
        data: userProfile,
      },
    })
  ),

  on(initializeWithNoToken, (state): AppState => ({
    ...state,
    accessToken: undefined,
    refreshToken: undefined,
    expiresAt: null,
    sessionId: undefined,
    accountType: '',
    hasHydrated: true,
    authLoading: false,
    authUserInfo: null,
    userDetails: {
      ...state.userDetails,
      data: null,
    },
  })),

  on(adminLoginRequest, emailValidationRequest, (state): AppState => ({
    ...state,
    authLoading: true,
    authError: null,
  })),

  on(credentialsLoginMfaFallbackRequested, (state): AppState => ({
    ...state,
    authLoading: false,
    authError: null,
  })),

  on(adminLoginRedirectStarted, (state): AppState => ({
    ...state,
    authLoading: false,
    authError: null,
  })),

  on(adminLoginFailure, emailValidationFailure, (state, { error }): AppState => ({
    ...state,
    authLoading: false,
    authError: error,
  })),

  on(emailValidationSuccess, (state, { response }): AppState => ({
    ...state,
    authLoading: false,
    authError: null,
    authUserInfo: response,
  })),

  on(setAuthLoading, (state, { loading }): AppState => ({
    ...state,
    authLoading: loading,
  })),
  on(setAuthError, (state, { error }): AppState => ({
    ...state,
    authError: error,
  })),
  on(saveAuthUserInfo, (state, { userInfo }): AppState => ({
    ...state,
    authUserInfo: userInfo,
  })),
  on(adminLogout, adminSessionExpired, clearAuthSession, (state): AppState => ({
    ...state,
    accountType: '',
    sessionId: undefined,
    accessToken: undefined,
    refreshToken: undefined,
    expiresAt: null,
    hasHydrated: true,
    authLoading: false,
    authError: null,
    authUserInfo: null,
    userDetails: {
      ...state.userDetails,
      data: null,
    },
  })),

  on(initializeWithToken, (state, { token, sessionId, accountType, userProfile, expiresAt }):
  AppState => ({
    ...state,
    accessToken: token,
    refreshToken: undefined,
    expiresAt,
    sessionId: sessionId,
    accountType: accountType,
    hasHydrated: true,
    authLoading: false,
    authError: null,
    authUserInfo: null,
    userDetails: {
      ...state.userDetails,
      isLoading: false,
      error: null,
      data: userProfile,
    },
  })),

  on(saveRubickResponse, (state, { userProfile, rubickToken }): AppState => ({
    ...state,
    rubickResponse: {
      userProfile,
      rubickToken,
    },
  }))
);
